import { Api as defaultApi } from './api.js';
import { FormApi } from './formApi';
import { AdminResourceApi } from './adminResourceApi';
import { ResourceApi } from './resourceApi';
import { MetaApi } from './metaApi';
import { UploadApi } from './uploadApi';
import { WidgetGroupApi } from './widgetGroupApi';
import { BulkApi } from './bulkApi';
import { BasicEntity } from '../../types/entities';
import { UserApi } from './userApi';

export type ListView<T> = {
    [key in keyof T]: {
        original: T[key];
        view: string | null;
    };
};

export type ApiClient = {
    meta: MetaApi;
    upload: UploadApi;
    resource: <T extends BasicEntity>(resource: string) => ResourceApi<T>;
    adminResource: <T extends BasicEntity>(resource: string) => AdminResourceApi<T>;
    form: FormApi;
    widget_group: (pwgid: number) => WidgetGroupApi;
    bulk: <T extends BasicEntity>(resource: string) => BulkApi<T>;
    user: UserApi;
}

export const ApiClientFactory = ((basePath: string|null = window.baseUrl, api = defaultApi): ApiClient => {
    let url: string = basePath || `/${document.location.hostname}`;

    // remove trailing slash
    if (url.split('').reverse()[0] === '/') {
        const tempUrl = url.split('');
        tempUrl.pop();
        url = tempUrl.join('');
    }

    return {
        meta: new MetaApi(url, api),
        upload: new UploadApi(url, api),
        resource: <T extends BasicEntity>(resource: string): ResourceApi<T> => new ResourceApi<T>(url, resource, api),
        adminResource: <T extends BasicEntity>(resource: string): AdminResourceApi<T> => new AdminResourceApi<T>(url, resource, api),
        form: new FormApi(url, api),
        widget_group: (pwgid: number): WidgetGroupApi => new WidgetGroupApi(url, pwgid, api),
        bulk: <T extends BasicEntity>(resource: string): BulkApi<T> => new BulkApi<T>(url, resource, api),
        user: new UserApi(url, api),
    };
});
